import { useIntl } from 'react-intl';

import { surveyChoices } from '../../jsm-portal-playground-hr-data';
import { jsmPortalPlaygroundHrMessages as messages } from '../../jsm-portal-playground-hr-messages';

import {
	SurveyCell,
	SurveyHeadCell,
	SurveyTable,
	SurveyTableBody,
	SurveyTableHead,
	SurveyTableRow,
} from './survey-table';

/** Question 1's answers as a Choice / Responses / Percentages table — the chart's other view. */
export const SurveyChoiceTable = () => {
	const intl = useIntl();

	return (
		<SurveyTable caption={intl.formatMessage(messages.choiceTableCaption)}>
			<SurveyTableHead>
				<SurveyHeadCell isFirst>{intl.formatMessage(messages.columnChoice)}</SurveyHeadCell>
				<SurveyHeadCell width={205}>{intl.formatMessage(messages.columnResponses)}</SurveyHeadCell>
				<SurveyHeadCell width={245}>
					{intl.formatMessage(messages.columnPercentages)}
				</SurveyHeadCell>
			</SurveyTableHead>
			<SurveyTableBody>
				{surveyChoices.map((choice, index) => (
					<SurveyTableRow key={choice.id} index={index}>
						<SurveyCell isFirst>{intl.formatMessage(choice.label)}</SurveyCell>
						<SurveyCell>{intl.formatNumber(choice.responses)}</SurveyCell>
						<SurveyCell>
							{intl.formatNumber(choice.share, { style: 'percent', minimumFractionDigits: 1 })}
						</SurveyCell>
					</SurveyTableRow>
				))}
			</SurveyTableBody>
		</SurveyTable>
	);
};
